export const getNetContext = {
    checkout: 'checkout',
    trocaMetodo: 'trocaMetodo',
    trocaRecorrencia: 'trocaRecorrencia',
    acordo: 'acordo',
    meusCartoes: 'meusCartoes',
}
  